<div class="dialog-container" *ngIf="!toastRef.data.joinScreen">
   <span style="position: relative;right:30px">{{ toastRef.data.fact }}</span> 
    <br/>
    <div mat-dialog-actions align="end" style="position: relative;left:50px;margin-top: 5px;">
        <button mat-button color="warn" (click)="closeDialog('tes')" style="color: #DE1B36;">Accept </button>
        <button mat-button (click)="closeDialog1('tes')">Cancel </button>
    </div>
   
</div>

<div class="dialog-container" *ngIf="toastRef.data.joinScreen">
    <span >{{ toastRef.data.fact }}</span> 
     <br/>
     <div mat-dialog-actions align="end">
         <button mat-button color="warn" (click)="closeDialog('tes')" style="color: #DE1B36;">Accept </button>
         <button mat-button (click)="closeDialog1('tes')">Cancel </button>
     </div>
    
 </div>